import { floor } from '../../utils/math';
import formatBitrate from '../../utils/format-bitrate';

/**
 * Generate a localised label for a quality level
 *
 * @param  {Object} qualityLevel The quality level to localise
 * @param  {Object} locale       The localisation strings
 * @return {String}
 */
export function qualityLabel (qualityLevel, locale) {
  const label = typeof qualityLevel === 'string' ? qualityLevel : qualityLevel.label;
  if (locale && locale.player[label]) {
    return locale.player[label];
  }
  return label;
}

/**
 * Generate a localised bitrate string from a quality level
 *
 * @param  {Object} qualityLevel The quality level to localise
 * @param  {Object} locale       The localisation strings
 * @return {String}
 */
export function qualityFormattedBitrate (qualityLevel, locale) {
  if (!qualityLevel.bitrate) return '';
  return floor(qualityLevel.bitrate / 1000, 0) + ((locale && locale.kbps) || 'kbps');
}

/**
 * Generate a localised bandwith per hour string from a quality level
 *
 * @param  {Object} qualityLevel The quality level to localise
 * @param  {Object} locale       The localisation strings
 * @return {String}
 */
export function qualityFormattedUsage (qualityLevel, locale) {
  if (!qualityLevel.bitrate) return '';
  return formatBitrate(qualityLevel.bitrate, 'MBph') + ((locale && locale.mbph) || 'MB/hr');
}

export default {
  qualityLabel,
  qualityFormattedBitrate,
  qualityFormattedUsage
};
